<div class="domain-lists maximized-component">
    <div class="grids-container">
        <div id="domain-lists-section">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
                [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
                [columnDefs]="columnDefs" [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
                [responseCallback]="responseCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
                [rowSelection]="domainListSelection" [pagerVisible]="false" [onSelectionChanged]="onSelectionChanged"
                [loadDataFinishedCallback]="loadDataFinishedCallback" [updateStatusType]="updateStatusType">
            </res-generic-grid>
            <ng-template #headerTemplate>
                <div class="parent-header">
                    <span>Domain Lists</span>
                    <button type="button" data-automation-id="domain-lists-new-domain-list-button"
                        *ngIf="hasPermissions" class="secondary-button" (click)="addNewDomainList()">
                        <i class="fa fa-plus"></i>New Domain List ...</button>
                </div>
            </ng-template>
        </div>
        <res-resizer [attr.data-automation-id]="'domain-lists-resizer'" anchor="left"
            resizingElementId="domain-lists-section" secondElementId="domains-section" [usePercentages]="true"
            [initSize]="60" [minSize]="20" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div id="domains-section">
            <res-generic-grid [automationId]="domainEntriesAutoId" [rowSelection]="domainsSelection"
                [pagerVisible]="false" [columnDefs]="colDefsDomains" [rowClassRules]="rowDisableRulesDomains"
                [headerTemplate]="domainsHeaderTemplate" [onSelectionChanged]="countSelectedDomains"
                [gridContext]="gridContext" [onCustomFilterCallback]="onCustomFilterCallback">
            </res-generic-grid>
            <div class="entries-count-container" *ngIf="sysDomainIsSelected()">
                <span class="entries-count"
                    data-automation-id="domain-entries-count-label">{{domainGridEntriesCount}}</span>
            </div>
            <ng-template #domainsHeaderTemplate>
                <div class="parent-header" *ngIf="hasPermissions">
                    <span>Domains</span>
                    <button type="button" data-automation-id="domain-entries-add-domains-button"
                        class="secondary-button" (click)="addDomains()" *ngIf="!sysDomainIsSelected()">
                        <i class="fa fa-plus sizing-icons"></i>Add Domains ...
                    </button>
                    <div *ngIf="sysDomainIsSelected()" class="grids-header-container">
                        <div class="button-container">
                            <li class="dropdown" dropdown>
                                <button dropdownToggle type="button" class="primary-button"
                                    [ngClass]="[noDomainEntryIsSelected() ? 'disabled' : '']"
                                    data-automation-id="domain-entries-domain-button">
                                    <span>Domain</span>
                                    <i class="fa fa-caret-down"
                                        data-automation-id="domain-entries-domain-button-icon"></i>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu">
                                    <li class="menu-item" (click)="openDomainButton()">
                                        <div class="menu-item-icon">
                                            <span class="fa-stack">
                                                <i class="fa fa-at"></i>
                                                <i class="fa fa-stack-1x fa-plus"></i>
                                            </span>
                                        </div>
                                        <div class="menu-item-label"
                                            data-automation-id="domain-entries-add-to-new-domain-list-button">
                                            Add to New Domain List ...</div>
                                    </li>
                                    <li class="menu-item" (click)="openDomainButton(true)">
                                        <div class="menu-item-icon">
                                            <span class="fa-stack">
                                                <i class="fa fa-at"></i>
                                                <i class="fa fa-stack-1x fa-plus"></i>
                                            </span>
                                        </div>
                                        <div class="menu-item-label"
                                            data-automation-id="domain-entries-add-to-existing-domain-list-button">
                                            Add to Existing Domain List ...</div>
                                    </li>
                                </ul>
                            </li>
                            <span [disabled]="sysDomainIsSelected()"
                                data-automation-id="domain-entries-selected-count-label"
                                class="li-selected-label">Selected: <span class="number-label">
                                    {{numberOfSelectedDomains}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="grid-row-delete" *ngIf="hasPermissions">
                        <span (click)="deleteSelectedDomains()"
                            [ngClass]="[numberOfSelectedDomains > 0 && !sysDomainIsSelected() ? 'enabled-class' : 'disabled-class']"
                            data-automation-id="domain-entries-delete-selected-button">
                            <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>